// import Button from "../components/Button.tsx";
// import {
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiEyeLine,
//   RiTimeLine,
//   RiShieldCheckLine,
//   RiAddLine,
//   RiDeleteBin2Line,
// } from "@remixicon/react";
// import Table from "../components/Table.tsx";

import Dashboard from "./HomeSectionContent/Dashboard.tsx";

const TestSection = () => {
  //return <div> empty section </div>
  return <Dashboard />;
};

export default TestSection;
